export const invoicesNational = {
	title: "Facturas Fiscales",
	description:
		"Descarga individual o grupo de Facturas fiscales emitidas en el período seleccionado.",
	acitons: {
		exportToExcel: "Exportar a Excel",
		downloadXml: "Descarga de XML",
	},
	filters: {
		fiscalProfileLabel: "Perfil fiscal",
		invoiceNumberLabel: "Número de factura",
		invoiceNumberPlaceholder: "Buscar por número de factura",
		rangePickerLabel: "Período de emisión",
		statusLabel: "Estado",
		allInvoices: "Todas las facturas fiscales",
		canceledInvoices: "Facturas fiscales canceladas",
	},
	table: {
		issuedAt: "Emitida en",
		mode: "Modo de emisión",
		createdBy: "Empleado",
		fiscalProfile: "Perfil fiscal",
		eventDate: "Fecha del evento",
		isCanceled: "Cancelada",
		serie: "Serie factura",
		num: "N° factura",
		value: "Valor factura",
		actions: "Acciones",
		downloadInvoice: {
			download: "Descargar",
			pdf: "PDF",
			image: "Imagen",
			xml: "XML",
			cancelXml: "XML de cancelación",
		},
		cancelInvoice: {
			yesCancel: "Sí, cancelar factura fiscal",
			confirm: "ok",
			areYouSure: "¿Está seguro que desea cancelar la factura fiscal?",
			timeLimitExplanation:
				"Facturas emitidas hace más de 30 minutos no pueden ser canceladas",
			cancel: "Cancelar",
		},
		paginationTotal: " de {{total}}",
	},
};
